__webpack_require__.p = "/learn-words-front/";